const inventoryObjectToInventoryRequest = (object) => {
    return {
        product_id: object.productId,
        location_id: object.locationId,
        on_hand: object.onHand,
        available: object.available,
        allocated: object.allocated,
        reorder: object.reorder,
    };
};

const inventoryResponseToInventoryObject = (response, products, locations) => {
    const product = products?.find(p => p.id === response.product_id);
    const location = locations?.find(l => l.id === response.location_id);
    return {
        id: response.id,
        userId: response.user_id,
        createdAt: response.created_at,
        productId: product?.id,
        productName: product?.name,
        locationId: location?.id,
        locationName: location?.name,
        onHand: response.on_hand,
        available: response.available,
        allocated: response.allocated,
        reorder: response.reorder,
    };
};

export { inventoryResponseToInventoryObject, inventoryObjectToInventoryRequest };
